import React from "react"
import PropTypes from "prop-types"

import MenuItem from '@material-ui/core/MenuItem';
import TextField from "@material-ui/core/TextField"

export default class Select extends React.Component {
  static propTypes = {
    classes: PropTypes.object,
    onChange: PropTypes.func,
    onFieldChange: PropTypes.func,
    onFieldFlush: PropTypes.func,
    options: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    required: PropTypes.bool,
    fullWidth: PropTypes.bool,
    inPlace: PropTypes.bool, // Ignored
  }

  static defaultProps = { margin: "normal" }

  _handleChange = e => {
    if (this.props.onChange) {
      this.props.onChange(e)

      if (e.isDefaultPrevented()) {
        return
      }
    }

    const event = this._parseEvent(e)
    this.props.onFieldChange(event)
    this.props.onFieldFlush(event)
  }

  _parseEvent(e) {
    return this._parseValue(e.target.value)
  }

  _parseValue(value) {
    return { value, rawValue: value }
  }

  _handleOptionSelect = value => {
    this.props.onFieldChange({ value, rawValue: value })
    this.props.onFieldFlush({ value, rawValue: value })
  }

  _valueLabel(value) {
    if (Array.isArray(this.props.options)) {
      return value
    }

    return this.props.options[value]
  }

  _optionValues() {
    if (Array.isArray(this.props.options)) {
      return this.props.options
    }

    return Object.keys(this.props.options)
  }

  _renderOptions() {
    const { required } = this.props

    const children = this._optionValues().map(v => (
      <MenuItem key={v} value={v}>
        {this._valueLabel(v)}
      </MenuItem>
    ))

    if (!required) {
      children.unshift(<MenuItem key="__empty__" onSelect={this._handleOptionSelect} />)
    }

    return children
  }

  _renderValue = v => v

  render() {
    const {
      onFieldChange,
      onFieldFlush,
      options,
      value,
      required,
      inPlace, // Ignored but stripping from otherProps

      ...otherProps
    } = this.props

    const inputValue = this._valueLabel(value) || ""

    return (
      <TextField
        {...otherProps}
        value={inputValue}
        required={required}
        onChange={this._handleChange}
        select
        SelectProps={{ renderValue: this._renderValue }}
      >
        {this._renderOptions()}
      </TextField>
    )
  }
}



// WEBPACK FOOTER //
// ../ui-kit/src/components/ui-Field/Select.js